<template>
  <div class="registration">
    <Row class="header" justify="space-between" type="flex" align="middle">
      <Tabs value="name1">
        <TabPane :label="$t('global.text21')" disabled />
        <TabPane name="name1" :label="$t('global.text22')" />
      </Tabs>
      <span></span>
    </Row>
    <div class="registration_attachment">
      <div
        v-for="(v, i) in data.attachments"
        style="margin-bottom: 30px"
        :key="i"
      >
        <div
          style="
            padding-bottom: 15px;
            margin-bottom: 15px;
            border-bottom: 1px solid #e8eaec;
          "
        >
          <p class="groupName text-left">
            {{ v.name }}
            <Tag color="orange" v-if="v.requiredFlag">
              {{ $t('global.text24') }}
            </Tag>
          </p>
          <p class="gary-text text-left">{{ v.description }}</p>
        </div>
        <Upload
          class="text-left"
          :on-success="fileSuccess"
          :headers="header"
          :before-upload="handleUpload"
          :default-file-list="
            $_.filter(form.attachments, (val) => {
              return val.dictItemId === v.dictItemId;
            })
          "
          :on-error="fileError"
          :on-remove="del"
          accept="image/jpeg, image/png, image/jpeg, .dotx, application/vnd.openxmlformats-officedocument.wordprocessingml.template, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document.pdf, application/pdf, .wps, application/vnd.ms-works, application/vnd.ms-excel, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :action="`${mainApiEndpoint}/rest/api/v1/mobile/employee/document/attachment/${$route.params.teamId}/${$route.params.formId}/${v.dictItemId}`"
          :max-size="20 * 1024"
          :on-exceeded-size="onExceededSize"
        >
          <Button icon="ios-cloud-upload-outline">
            {{ $t('apply.add_attachments') }}
          </Button>
          <span class="gary-text" style="margin-left: 10px">
            {{ $t('global.img_file_text') }}
          </span>
        </Upload>
      </div>
      <div class="footer">
        <Button type="primary" @click="$router.back()" ghost>
          {{ $t('global.text18') }}
        </Button>
        <Button type="primary" style="margin-left: 15px" @click="next">
          {{ $t('global.text17') }}
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
import app_config from '@/commons/app_config';
import { mapState, mapMutations } from 'vuex';
import axios from 'axios';
export default {
  data() {
    return {
      sb_loading: false,
      mainApiEndpoint: app_config.mainApiEndpoint,
      success_files: [],
      header: {},
      params: {}
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.r_form,
      form: (state) => state.form
    })
  },
  created() {
    if (this.form.attachments) {
      _.forEach(this.form.attachments, (e) => {
        this.success_files.push({
          key: e.key,
          dictItemId: e.dictItemId
        });
      });
    } else {
      this.$Modal.error({
        title: this.$t('global.warn'),
        content: this.$t('global.fileError')
      });
    }
  },
  mounted() {
    this.params = JSON.parse(localStorage.getItem('params'));
  },
  methods: {
    ...mapMutations({
      set_form1: 'set_form1'
    }),
    async handleUploadTwo() {
      let token = await this.$auth.getAccessToken();
      this.header = {
        'X-TENANT-ID': this.$route.params.teamId,
        Authorization: `bearer ${token.accessToken}`
      };
    },
    onExceededSize() {
      this.$Message.error(this.$t('global.img_file_text'));
    },
    async handleUpload() {
      this.header = {
        'X-TENANT-ID': this.params.teamId,
        Authorization: `bearer ${this.params.token.access_token}`
      };
    },
    fileSuccess(response) {
      this.form.attachments.push(response);
      this.set_form1(this.form);
      this.success_files.push({
        key: response.key,
        dictItemId: response.dictItemId
      });
      this.$Message.success(this.$t('global.import_success_msg'));
    },
    next() {
      let validate = [];
      _.forEach(this.data.attachments, (v) => {
        if (v.requiredFlag) {
          if (
            !_.find(this.success_files, (e) => e.dictItemId === v.dictItemId)
          ) {
            validate.push(v.name);
          }
        }
      });
      if (validate.length > 0) {
        this.$Message.error(
          `${validate.join(',')}${this.$t('apply.not_empty')}`
        );
      } else {
        this.$router.push({ path: '/improveEmployeeFiles/success' });
      }
    },
    fileError(response, res) {
      this.$Message.error(res.message);
    },
    async del(v) {
      let dictItemId = v.response ? v.response.dictItemId : v.dictItemId;
      let key = v.response ? v.response.key : v.key;
      try {
        await axios({
          method: 'DELETE',
          url: `${this.mainApiEndpoint}/rest/api/v1/mobile/employee/document/attachment/${this.$route.params.teamId}/${this.$route.params.formId}/${dictItemId}?key=${key}`,
          headers: {
            'X-TENANT-ID': this.$route.params.teamId
          }
        });
        _.remove(this.success_files, (i) => {
          return i.key === key;
        });
        _.remove(this.form.attachments, (val) => {
          return val.key === key;
        });
        this.set_form1(this.form);
        this.$Message.success(this.$t('apply.deleted'));
      } catch (e) {
        this.$Message.error({
          content: e.response.data.message,
          duration: 8
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.header {
  justify-content: center;
  height: 50px;
}

.registration {
  overflow-y: scroll;
  height: 100vh;
}
.registration_attachment {
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
  padding-bottom: 50px;
  box-sizing: content-box;
}
.footer,
.mobile-footer {
  margin-top: 50px;
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .registration_attachment {
    width: 100%;
    padding: 15px 15px 100px 15px;
  }
}
</style>
